import { createApi } from "@reduxjs/toolkit/query/react";
import type { GetDataConfidenceRequest, GetDataConfidenceResponse } from "../contracts";
import { baseQueryWithAuth } from "./api";

export const dataConfidenceApi = createApi({
    reducerPath: "dataConfidenceApi",
    baseQuery: baseQueryWithAuth,
    endpoints: builder => ({
        getDataConfidence: builder.query<GetDataConfidenceResponse, GetDataConfidenceRequest>({
            query: body => ({
                url: "dataconfidence",
                method: "POST",
                body
            })
        })
    })
});

export const {
    useGetDataConfidenceQuery,
    useLazyGetDataConfidenceQuery
} = dataConfidenceApi;
